module.exports = "../../../../platform/assets/pageMainIcon/cd-personnel-submitter.svg";